import {ParticleService} from '@core/services/particle.service';
import {StringUtility} from '@shared/utility/string-utility';

import {
  CHANGE_CONVERSATION_TITLE_SUCCESS,
  CollaborationActions,
  CONVERSATION_MARKS_CHANGED,
  ConversationMarksChangedAction,
  DELETE_CONVERSATION_MESSAGE_SUCCESS,
  DELETE_MESSAGE_FROM_OTHERS_NOTIFICATION,
  DeleteConversationMessageSuccessAction,
  DeleteMessageFromOthersNotificationAction,
  GET_COLLABORATION_AVATAR_SUCCESS,
  GET_CONTEXT_BY_PATH_SUCCESS,
  GET_CONVERSATION_CHAT_SUCCESS,
  GET_CONVERSATION_LIST_SUCCESS,
  GET_CONVERSATION_SUCCESS,
  GetCollaborationAvatarSuccessAction,
  GetContextByPathSuccessAction,
  GetConversationChatSuccessAction,
  GetConversationListSuccessAction,
  GetConversationSuccessAction,
  LIVE_SUPPORT_JOINED_NOTIFICATION,
  MANAGE_PARTICIPANTS_SUCCESS,
  LiveSupportJoinedNotificationAction,
  NEW_COLLABORATION_MESSAGE_NOTIFICATION,
  NEW_MESSAGE_NOTIFICATION,
  NewMessageNotificationAction,
  SEND_MESSAGE_SUCCESS,
  SendMessageSuccessAction,
  SEND_MESSAGE_CONFIRMED,
  SendMessageConfirmedAction,
  OTHERS_MANAGE_PARTICIPANTS,
  EDIT_CONVERSATION_MESSAGE,
  OTHERS_EDIT_CONVERSATION_MESSAGE,
  EDIT_CONVERSATION_MESSAGE_SUCCESS,
  OTHERS_MESSAGE_READ,
  MESSAGE_READ_SUCCESS,
  LEAVE_CONVERSATION_SUCCESS,
  OTHERS_LEAVE_CONVERSATION, OTHERS_CREATE_CONVERSATION, OthersCreateConversationNotificationAction,
  SET_CURRENT_TYPE_OF_SAVED_FILTER, SetCurrentTypeOfSavedFilter, OTHERS_TRACK_ACTIVITY,
  OthersTrackActivityNotificationAction, SET_CURRENT_TEXT_EDITOR_ID, SetCurrentTextEditorId,
  OTHERS_TRACK_BATCH_ACTIVITY, OthersTrackBatchActivityNotificationAction,
  MESSAGE_READ, DELETE_CONVERSATION, LEAVE_CONVERSATION, MANAGE_PARTICIPANTS
} from './collaboration.action';
import {GET_SELECTED_TASK_SUCCESS} from '../../store/task-manager.action';
import {GET_USER_INFO_SUCCESS, GetUserInfoSuccessAction} from '@shared/store/actions/auth.actions';
import {Conversation, ConversationListInfo} from "./collaboration.models";
import {ActivityFilterType} from "./activity.model";
import {mentionsReader} from '../messenger/message-mentions';
import {chatActivity, listHolds, orderChatList} from '../messenger/chat-list-order';

export interface CollaborationState {
  currentChatConversation: any;
  newMessage: any;
  newConversation: any;
  editedMessage: any;
  deletedMessage: any;
  conversationListInfo: any;
  conversationList: any[];
  avatars: any;
  deleteMessageId: string;
  contextByPath: any;
  collaborationContext: any;
  showViewMoreInConversationList: boolean;
  lowestModifiedDateForThisConversationList: Date;
  currentActivityType: ActivityFilterType;
  otherTrackedActivity: any;
  otherTrackedBatchActivity: any[];
  userInfo: any;
  editorId: string;
}

export const initialState = <CollaborationState>{
  currentChatConversation: {},
  newMessage: null,
  newConversation: null,
  editedMessage: null,
  deletedMessage: null,
  conversationListInfo: new ConversationListInfo(),
  conversationList: [],
  avatars: {},
  deleteMessageId: null,
  contextByPath: {},
  collaborationContext: {},
  userInfo: {},
  showViewMoreInConversationList: false,
  lowestModifiedDateForThisConversationList: new Date(2200, 3, 1),
  currentActivityType: null,
  otherTrackedActivity: {},
  otherTrackedBatchActivity: [],
  editorId: null
};


export function CollaborationReducer(state: CollaborationState = initialState, action: any) {
  function getReadStatus(roles: any[]) {
    const readRoles = roles.filter(r => r.IsRead);
    if (!readRoles || readRoles.length === 0) {
      return 'Unread';
    }
    if (readRoles.length === roles.length) {
      return 'AllRead';
    }
    return 'SomeRead';
  }

  const getReadMessageState = function () {
    // console.log('before mark as read', action);
    const messages = action.payload.Payload;
    if (messages.length === 0) {
      return state;
    }
    // console.log('Mark as read messages', messages);
    const newState = {...state};
    if (state.currentChatConversation && state.currentChatConversation.messages) {
      const newConversation = {...newState.currentChatConversation};
      const newMessagesArray = [...newConversation.messages];
      const currentEmail = state['userInfo'].email;
      messages.forEach(message => {
        const existingMessage = state.currentChatConversation.messages.find(m => m.id === message.Id);
        if (existingMessage) {
          newConversation.unreadMessageCount = Math.max(0, newConversation.unreadMessageCount - 1);
        }
        if (existingMessage && existingMessage.isMine) {
          const index = state.currentChatConversation.messages.indexOf(existingMessage);
          let newMessage = newMessagesArray[index];
          newMessage = {...newMessage};
          const otherRoles = message.Roles.filter(r => r.User.Email !== currentEmail);

          newMessage.readStatus = getReadStatus(otherRoles);
          newMessagesArray[index] = newMessage;
        }
      });
      newState.currentChatConversation = newConversation;
      newConversation.messages = newMessagesArray;
    }
    let conversationListInfo = {...newState.conversationListInfo};
    if (!conversationListInfo) {
      conversationListInfo = new ConversationListInfo();
    } else if (conversationListInfo && !conversationListInfo.queryConversations) {
      conversationListInfo.queryConversations = [];
    }
    const conversationList = [...conversationListInfo.queryConversations];
    for (let i = 0; i < conversationList.length; i++) {
      if (conversationList[i].lastMessage && conversationList[i].lastMessage.id === messages[messages.length - 1].Id) {
        const conversation = {...conversationList[i]};
        conversation.lastMessage = {...conversation.lastMessage};
        conversation.lastMessage.readStatus = getReadStatus(messages[messages.length - 1].Roles);
      }
    }
    conversationListInfo.queryConversations = conversationList;
    newState.conversationListInfo = conversationListInfo;
/*    console.log('Old State', state);
    console.log('New State', newState);*/
    return newState;
  };
  // THE LOADED LIST, KEPT RIGHT WITH NO LIST ON SCREEN (ITP-E-203-07): the toolbar's unread badge counts it, and it is
  // loaded once at startup, so these updates are what keep it true while the Chat panel is shut.
  const me = (state['userInfo'] && state['userInfo'].email || '').toLowerCase();
  const isMe = (email: string) => !!me && (email || '').toLowerCase() === me;
  /** The state with the loaded list's conversations replaced by `update`'s answer; the same state when nothing moved. */
  const withListConversations = function (from: CollaborationState, update: (conversations: any[]) => any[]): CollaborationState {
    const conversations = from.conversationListInfo && from.conversationListInfo.queryConversations;
    if (!conversations || !conversations.length) {
      return from;
    }
    const updated = update(conversations);
    return updated === conversations ? from : {
      ...from,
      conversationListInfo: {...from.conversationListInfo, queryConversations: updated}
    };
  };
  /** One conversation of the list changed by `change`, others untouched. */
  const changeListConversation = function (from: CollaborationState, conversationId: string,
                                           change: (conversation: any) => any): CollaborationState {
    return withListConversations(from, conversations => conversations.some(c => c && c.id === conversationId)
      ? conversations.map(c => c && c.id === conversationId ? change(c) : c)
      : conversations);
  };
  /** The reader is out of the conversation: the badge no longer counts it. */
  const markLeft = (from: CollaborationState, conversationId: string) =>
    changeListConversation(from, conversationId, conversation => ({...conversation, hasLeft: true}));
  /**
   * ITP-E-240-04: `payload`, a message just written, is its conversation's latest: the row shows it and is keyed by its date,
   * and the list keeps its one order, so the row moves to the top of the unpinned rows. A conversation the list does not hold
   * is left alone; the effects read the list again for it.
   */
  const withLatestMessage = (from: CollaborationState, payload: any, change: (conversation: any) => any): CollaborationState =>
    withListConversations(from, conversations => listHolds(conversations, payload && payload.ConversationId)
      ? orderChatList(conversations.map(c => c && c.id === payload.ConversationId
        ? {...change(c), lastMessageReceived: payload.CreatedDate || c.lastMessageReceived}
        : c))
      : conversations);
  /**
   * ITP-E-249-08: the reader's own message, which the server just took (`payload`, the stored message the send is answered
   * with), is their row's latest in the tab that sent it. That tab hears the message's frame as its command's answer, never
   * as `[OTHERS]`, so this is the row's one update there. An answer can come late: a row that already shows a later message
   * (a reply, the reader's next send) keeps it.
   */
  const withSentMessage = (from: CollaborationState, payload: any): CollaborationState => {
    const conversations = payload && from.conversationListInfo && from.conversationListInfo.queryConversations || [];
    const listed = conversations.find(c => c && c.id === payload.ConversationId);
    return listed && chatActivity(listed) > Date.parse(payload.CreatedDate)
      ? from
      : withLatestMessage(from, payload, conversation =>
        ({...conversation, lastMessage: getNewMessage(payload, true, state['userInfo'] ? state['userInfo'].email : null)}));
  };

  const getLeaveConversationState = function () {
    if (!action.payload || !action.payload.Payload) {
      return state;
    }
    const conversationId = action.payload.Payload.ConversationId;
    const email = action.payload.Payload.Email;
    if (state.currentChatConversation.id === conversationId && state.currentChatConversation.roles) {
      const roles = [...state.currentChatConversation.roles];
      const role = roles.find(o => o.user.email === email);
      if (role) {
        const index = roles.indexOf(role);
        roles.splice(index, 1);
        const newState = {...state, currentChatConversation: {...state.currentChatConversation, roles}};
        return newState;
      }
      return state;
    }
    return state;
  };
  switch (action.type) {
    case GET_USER_INFO_SUCCESS:
      const userInfo = (action as GetUserInfoSuccessAction).userInfo;
      return {...state, userInfo: userInfo};
    case GET_CONVERSATION_CHAT_SUCCESS: {
      const data = (action as GetConversationChatSuccessAction).data;
      const lastSequence = (action as GetConversationChatSuccessAction).lastSequence;
      // console.log('this should hit here', data, lastSequence);
      let chatById = data.chatById ? data.chatById : data.supportChatById;
      if (chatById && state.currentChatConversation && chatById.id && chatById.id === state.currentChatConversation.id && lastSequence > 0) {
        if (chatById.maximumSequenceNumberOfCurrentMessageRange <= state.currentChatConversation.lowestSequenceNumberOfCurrentMessageRange - 1) {
          let currentChatConversationObj = {...state.currentChatConversation};
          currentChatConversationObj.navigateToSequnceNumber = chatById.maximumSequenceNumberOfCurrentMessageRange;
          if (!currentChatConversationObj.messages) {
            currentChatConversationObj.messages = [];
          }
          if (chatById.messages && chatById.messages.length) {
            chatById.messages.reverse();
            chatById.messages.forEach(message => {
              if (currentChatConversationObj.messages.filter(msg => msg.id === message.id).length === 0) {
                if (message.sequence < currentChatConversationObj.lowestSequenceNumber) {
                  currentChatConversationObj.lowestSequenceNumber = message.sequence;
                }
                if (message.sequence < currentChatConversationObj.lowestSequenceNumberOfCurrentMessageRange) {
                  currentChatConversationObj.lowestSequenceNumberOfCurrentMessageRange = message.sequence;
                }
                if (message.sequence > currentChatConversationObj.maximumSequenceNumberOfCurrentMessageRange) {
                  currentChatConversationObj.maximumSequenceNumberOfCurrentMessageRange = message.sequence;
                }
                currentChatConversationObj.messages.unshift(message);
              }
            });
          }
          // currentChatConversationObj.messages.unshift(chatById.messages ? chatById.messages : []);
          chatById = {...currentChatConversationObj};
        }
      }
      return {
        ...state,
        currentChatConversation: chatById, newMessage: null
      };
    }
    case GET_CONVERSATION_SUCCESS: {
      const conversationData = (action as GetConversationSuccessAction).data;
      // console.log('conversation in reducer:', conversationData);
      let conversation = {};
      if (conversationData && conversationData.conversation) {
        conversation = conversationData.conversation;
      }
      return {
        ...state,
        currentChatConversation: conversation, newMessage: null
      };
    }
    case GET_CONVERSATION_LIST_SUCCESS: {
      const data = (action as GetConversationListSuccessAction).data;
      const queryContainsModifiedDate = (action as GetConversationListSuccessAction).queryContainsModifiedDate;
      let chat = data && data.chat ? data.chat : new ConversationListInfo();
      if (!chat) {
        chat = new ConversationListInfo();
      }
      let conversationListInfo = {...state.conversationListInfo};
      if (!conversationListInfo) {
        conversationListInfo = new ConversationListInfo();
      }
      if (!queryContainsModifiedDate) { //initial cxall wild
        // ITP-E-240-04: the server's order, kept in the list's one rule.
        conversationListInfo = Array.isArray(chat.queryConversations)
          ? {...chat, queryConversations: orderChatList(chat.queryConversations)}
          : chat;
      } else {
        conversationListInfo.lowestModifiedDate = chat.lowestModifiedDate;
        conversationListInfo.hasMoreConversations = chat.hasMoreConversations;
        let conversationList = [...conversationListInfo.queryConversations];
        if (!conversationList) {
          conversationList = [];
        }
        chat.queryConversations.forEach(conversation => {
          if (conversationList.findIndex(c => c.id === conversation.id) === -1) {
            conversationList.push(conversation);
          }
        });
        conversationListInfo.queryConversations = orderChatList(conversationList);
      }
      return {
        ...state,
        conversationListInfo: conversationListInfo
      };
    }
    case SEND_MESSAGE_SUCCESS: {
      const payload = (action as SendMessageSuccessAction).payload;
      // console.log('send message success:', payload);
      const messageFromPayload = getNewMessage(payload, true, state['userInfo'] ? state['userInfo'].email : null);
      // ITP-E-240-04: the reader's own message is their list row's latest, in the tab that sent it.
      const listed = withSentMessage(state, payload);

      let currentChatConversationObj = state.currentChatConversation;
      currentChatConversationObj.navigateToSequnceNumber = null;
      if (currentChatConversationObj) {
        if (currentChatConversationObj.hasLeft || (currentChatConversationObj.roles && currentChatConversationObj.roles.findIndex(u => u.user.email === state['userInfo'].email) === -1)) {
          return listed;
        }
        currentChatConversationObj = {...state.currentChatConversation};
        if (!currentChatConversationObj.messages) {
          currentChatConversationObj.messages = [];
        }
        if (currentChatConversationObj.messages.filter(message => message.id === messageFromPayload.id).length === 0) {
          currentChatConversationObj.messages.push(messageFromPayload);
          if (messageFromPayload.sequence < currentChatConversationObj.lowestSequenceNumber) {
            currentChatConversationObj.lowestSequenceNumber = messageFromPayload.sequence;
          }
          if (messageFromPayload.sequence < currentChatConversationObj.lowestSequenceNumberOfCurrentMessageRange) {
            currentChatConversationObj.lowestSequenceNumberOfCurrentMessageRange = messageFromPayload.sequence;
          }
          if (messageFromPayload.sequence > currentChatConversationObj.maximumSequenceNumberOfCurrentMessageRange) {
            currentChatConversationObj.maximumSequenceNumberOfCurrentMessageRange = messageFromPayload.sequence;
          }
        }
      }
      currentChatConversationObj.messages.sort((a, b) => {
        if (a.sequence < b.sequence) {
          return -1;
        }
        if (a.sequence > b.sequence) {
          return 1;
        }
        return 0;
      });
      const contextByPathDeepClone = updateContextByPath(state, payload, messageFromPayload);
      return {
        ...listed,
        contextByPath: contextByPathDeepClone,
        currentChatConversation: currentChatConversationObj,
        newMessage: messageFromPayload
      };
    }
    case SEND_MESSAGE_CONFIRMED:
      // ITP-E-249-08: the server took the reader's send, so their row shows it now. The thread is left to the chat's read
      // (`getChat`) or to SEND_MESSAGE_SUCCESS, which follows a send that reads no chat.
      return withSentMessage(state, (action as SendMessageConfirmedAction).payload);
    case DELETE_CONVERSATION_MESSAGE_SUCCESS: {
      const payload = (action as DeleteConversationMessageSuccessAction).payload.Payload;
      // console.log(payload);
      let deletedMessage = getNewMessage(payload, state['userInfo'].email === payload.CreatedBy.Email);
      return {
        ...state,
        deleteMessageId: payload.Id,
        deletedMessage: deletedMessage
      };
    }

    case DELETE_MESSAGE_FROM_OTHERS_NOTIFICATION: {
      const payload = (action as DeleteMessageFromOthersNotificationAction).payload.Payload;
      let deletedMessage = getNewMessage(payload, state['userInfo'].email === payload.CreatedBy.Email);
      let returnState = {...state};
      if (state.currentChatConversation.id === payload.ConversationId || (state.contextByPath && state.contextByPath.conversations && state.contextByPath.conversations.findIndex(c => c.id === payload.ConversationId) !== -1) ) {
        returnState = {
          ...returnState,
          deleteMessageId: payload.Id
        };
      }
      let conversationListInfo = {...state.conversationListInfo};
      if (!conversationListInfo) {
        conversationListInfo = new ConversationListInfo();
      } else if (conversationListInfo && !conversationListInfo.queryConversations) {
        conversationListInfo.queryConversations = [];
      }
      const conversationList = [...conversationListInfo.queryConversations];
      if (payload && payload.IsDeleted && conversationList.filter(e => e.id === payload.ConversationId).length > 0) {
        const index = conversationList.map(function (e) {
          return e.id;
        }).indexOf(payload.ConversationId);
        const targetConversation = {...conversationList[index]};
        if (targetConversation && (targetConversation.roles && targetConversation.roles.findIndex(u => u.user.email === state['userInfo'].email) !== -1)) {
          if (targetConversation.lastMessage && targetConversation.lastMessage.id === payload.Id) {
            let newMessage = {...targetConversation.lastMessage};
            newMessage.message = 'Message deleted!';
            targetConversation.lastMessage = newMessage;
            // console.log('NewState after message change', newState);
            conversationList[index] = targetConversation;
            conversationListInfo.queryConversations = conversationList;
            returnState = {
              ...returnState,
              conversationListInfo: conversationListInfo,
              deleteMessageId: payload.Id
            };
          }
        }
      }
      return {
        ...returnState,
        deleteMessageId: payload.Id,
        deletedMessage: deletedMessage
      };
    }

    case OTHERS_CREATE_CONVERSATION: {
      const payload = (action as OthersCreateConversationNotificationAction).payload.Payload;
      // console.log('others conversation:', payload, state.contextByPath);
      let newConversation = getNewConversation(payload, state['userInfo'].email);
      if (payload && state.contextByPath && state.contextByPath.id === payload.ParentId) {
        let newContext = {...state.contextByPath};
        if (!newContext.conversations) {
          newContext.conversations = [];
        }
        if (newContext.conversations.filter(conv => conv.id === payload.Id).length === 0) {
          newContext.conversations.push(newConversation);
        }
        return {
          ...state,
          contextByPath: newContext,
          newConversation: newConversation
        };
      }
      return {
        ...state,
        newConversation: newConversation
      };
    }
    case OTHERS_TRACK_ACTIVITY: {
    const payload = (action as OthersTrackActivityNotificationAction).payload.Payload;
    //console.log('others track activity:', payload);
    if (payload && payload.ParentId && payload.Id) {
      let otherTrackedActivity = StringUtility.convertKeysPascalToCamel(payload); // lets make it camelize through command
      return {
        ...state,
        otherTrackedActivity: otherTrackedActivity,
      };
    }
    return state;
  }
    case OTHERS_TRACK_BATCH_ACTIVITY: {
      const payload = (action as OthersTrackBatchActivityNotificationAction).payload.Payload;
      if (payload) {
        const otherTrackedBatchActivity = payload; // lets make it camelize through command
        return {
          ...state,
          otherTrackedBatchActivity: otherTrackedBatchActivity,
        };
      }
      return state;
    }


    case NEW_COLLABORATION_MESSAGE_NOTIFICATION: // Do not delete it. this line for executing new message notification body
    case NEW_MESSAGE_NOTIFICATION: {
      const payload = (action as NewMessageNotificationAction).payload.Payload;
      // console.log('new message conversation:', payload, state.currentChatConversation);
      let returnState = {...state};
      if (state.currentChatConversation && payload && state.currentChatConversation.id === payload.ConversationId) {
        if (state.currentChatConversation.hasLeft || (state.currentChatConversation.roles && state.currentChatConversation.roles.findIndex(u => u.user.email === state['userInfo'].email) === -1)) {
          return state;
        }
        const currentChatConversationObj = {...state.currentChatConversation};
        currentChatConversationObj.navigateToSequnceNumber = null;
        if (!currentChatConversationObj.messages) {
          currentChatConversationObj.messages = [];
        }
        const newMsg = getNewMessage(payload, state['userInfo'].email === payload.CreatedBy.Email, state['userInfo'].email,
          state['userInfo'].companyId);
        if (currentChatConversationObj.messages.filter(message => message.id === newMsg.id).length === 0) {
          if (newMsg.sequence < currentChatConversationObj.lowestSequenceNumber) {
            currentChatConversationObj.lowestSequenceNumber = newMsg.sequence;
          }
          if (newMsg.sequence < currentChatConversationObj.lowestSequenceNumberOfCurrentMessageRange) {
            currentChatConversationObj.lowestSequenceNumberOfCurrentMessageRange = newMsg.sequence;
          }
          if (newMsg.sequence > currentChatConversationObj.maximumSequenceNumberOfCurrentMessageRange) {
            currentChatConversationObj.maximumSequenceNumberOfCurrentMessageRange = newMsg.sequence;
          }
          currentChatConversationObj.messages.push(newMsg);
          currentChatConversationObj.unreadMessageCount = currentChatConversationObj.unreadMessageCount + 1;
        }
        currentChatConversationObj.messages.sort((a, b) => {
          if (a.sequence < b.sequence) {
            return -1;
          }
          if (a.sequence > b.sequence) {
            return 1;
          }
          return 0;
        });
        returnState = {
          ...returnState,
          currentChatConversation: currentChatConversationObj,
          newMessage: newMsg
        };
      }
      let conversationListInfo = {...state.conversationListInfo};
      if (!conversationListInfo) {
        conversationListInfo = new ConversationListInfo();
      } else if (conversationListInfo && !conversationListInfo.queryConversations) {
        conversationListInfo.queryConversations = [];
      }
      const conversationList = [...conversationListInfo.queryConversations];
      if (payload && conversationList.filter(e => e.id === payload.ConversationId).length > 0) {
        const index = conversationList.map(function (e) {
          return e.id;
        }).indexOf(payload.ConversationId);
        const targetConversation = conversationList[index];
        if (targetConversation && !targetConversation.hasLeft && (targetConversation.roles && targetConversation.roles.findIndex(u => u.user.email === state['userInfo'].email) !== -1)) {
          // The reader's own message, sent from another tab, is never unread to them (ITP-E-203-07).
          const own = isMe(payload.CreatedBy && payload.CreatedBy.Email);
          conversationList[index] = {
            ...targetConversation,
            unreadMessageCount: (targetConversation.unreadMessageCount || 0) + (own ? 0 : 1),
            // ITP-E-207-03 (B-02): a message mentioning the reader marks the row until they read past it, as the server does.
            hasUnreadMention: !!targetConversation.hasUnreadMention || (!own && mentionsReader(payload, isMe)),
            lastMessage: getNewMessage(payload, own),
            // ITP-E-240-04: any row (text, card, call, system line) is the chat's latest: its date keys the row.
            lastMessageReceived: payload.CreatedDate || targetConversation.lastMessageReceived
          };
          // ITP-E-240-04: the list keeps its one order, so the row moves to the top of the unpinned rows.
          conversationListInfo.queryConversations = orderChatList(conversationList);
          returnState = {
            ...returnState,
            conversationListInfo: conversationListInfo
          };
        }
      }
      const messageFromPayload = getNewMessage(payload, false);
      if (payload && state.contextByPath && state.contextByPath.conversations && state.contextByPath.conversations.length) {
        const contextByPathDeepClone = updateContextByPath(state, payload, messageFromPayload);
        returnState = {
          ...returnState,
          contextByPath: contextByPathDeepClone,
          newMessage: messageFromPayload
        };
      }
      return {
        ...returnState,
        newMessage: messageFromPayload
      };
    }
    // case LIVE_SUPPORT_JOINED_NOTIFICATION: {
    //   const payload = (action as LiveSupportJoinedNotificationAction).payload.Payload;
    //   console.log(payload);
    //   if (state.currentChatConversation.id === payload.Id) {
    //     const currentConversation = {...state.currentChatConversation};
    //     currentConversation.halted = payload.Halted;
    //     currentConversation.waitingMessage = payload.WaitingMessage;
    //     return {
    //       ...state,
    //       currentChatConversation: currentConversation
    //               };
    //   } else {
    //     return state;
    //   }
    // }
    case GET_COLLABORATION_AVATAR_SUCCESS: {
      const collaborationAvatarSuccessAction = (action as GetCollaborationAvatarSuccessAction);
      const avatars = {...state.avatars};
      avatars[collaborationAvatarSuccessAction.email] = collaborationAvatarSuccessAction.avatarString;
      return {
        ...state,
        avatars: avatars
      };
    }
    case GET_CONTEXT_BY_PATH_SUCCESS: {
      const contextByPath = (action as GetContextByPathSuccessAction).data.context;
      return {
        ...state,
        contextByPath: contextByPath
      };
    }
    case SET_CURRENT_TYPE_OF_SAVED_FILTER: {
      const currentActivityType = (action as SetCurrentTypeOfSavedFilter).payload;
      return {
        ...state,
        currentActivityType: currentActivityType
      };
    }
    case SET_CURRENT_TEXT_EDITOR_ID: {
      const editorId = (action as SetCurrentTextEditorId).editorId;
      return {
        ...state,
        editorId: editorId
      };
    }
    case CHANGE_CONVERSATION_TITLE_SUCCESS: {
      return {
        ...state,
        currentChatConversation: {
          ...state.currentChatConversation,
          title: action.payload.Title
        }
      };
    }
    case OTHERS_MANAGE_PARTICIPANTS: {
      action.payload = StringUtility.convertKeysPascalToCamel(action.payload);
      let participantsState = state;
      if (state.currentChatConversation && action.payload && action.payload.Payload
        && action.payload.payload.id && state.currentChatConversation.id === action.payload.payload.id) {
        participantsState = {
          ...state,
          currentChatConversation: {
            ...state.currentChatConversation,
            roles: [...action.payload.payload.roles]
          }
        };
      }
      // The list keeps the new roles too, so a reader taken out of the group stops counting it (ITP-E-203-07).
      const changed = action.payload && action.payload.payload;
      return changed && changed.id && Array.isArray(changed.roles)
        ? changeListConversation(participantsState, changed.id, c => ({...c, roles: [...changed.roles]}))
        : participantsState;
    }
    case OTHERS_LEAVE_CONVERSATION:
    case LEAVE_CONVERSATION_SUCCESS: {
      const left = action.payload && action.payload.Payload;
      const leaveState = getLeaveConversationState();
      // The reader left in another tab: the count drops it here too.
      return left && left.ConversationId && isMe(left.Email) ? markLeft(leaveState, left.ConversationId) : leaveState;
    }
    case GET_SELECTED_TASK_SUCCESS: {
      return {
        ...state,
        contextByPath: {}
      };
    }
    case OTHERS_EDIT_CONVERSATION_MESSAGE:
    case EDIT_CONVERSATION_MESSAGE_SUCCESS: {
      const message = action.payload.Payload;
      const newEditedMessage = getNewMessage(message, state['userInfo'].email === message.CreatedBy.Email);
      let returnState = {...state};
/*      if (message && state.contextByPath && state.contextByPath.conversations && state.contextByPath.conversations.length) {
        const contextByPathWithEditedMessage = updateEditedMessageInContextByPath(state, message, newEditedMessage);
        returnState = {
          ...returnState,
          contextByPath: contextByPathWithEditedMessage
        };
       }*/
      if (state.currentChatConversation && state.currentChatConversation.messages) {
        // console.log('Messages', state.currentChatConversation.messages);
        // console.log('message', message);
        const existingMessage = state.currentChatConversation.messages.find(m => m.id === message.Id);
        if (existingMessage) {
          const newConversation = {...state.currentChatConversation};
          newConversation.navigateToSequnceNumber = null;
          const newMessages = [...newConversation.messages];
          const index = state.currentChatConversation.messages.indexOf(existingMessage);
          let newMessage = {...newMessages[index]};

          newEditedMessage.replyTo = newMessage.replyTo;
          // ITP-E-207-08: an edit moves neither window, so the server's canEdit / canDeleteForEveryone stand until the next read.
          const windows = {canEdit: newMessage.canEdit, canDeleteForEveryone: newMessage.canDeleteForEveryone};
          newMessage = Object.assign(newEditedMessage, windows);
          newMessage.isTemporary = false;
          newConversation.messages = newMessages;
          newMessages[index] = newMessage;
          // console.log('NewState after message change', newState);
          returnState = {
            ...returnState,
            currentChatConversation: newConversation
          };
        }
      }


      let conversationListInfo = {...state.conversationListInfo};
      if (!conversationListInfo) {
        conversationListInfo = new ConversationListInfo();
      } else if (conversationListInfo && !conversationListInfo.queryConversations) {
        conversationListInfo.queryConversations = [];
      }
      const conversationList = [...conversationListInfo.queryConversations];
      if (message && conversationList.filter(e => e.id === message.ConversationId).length > 0) {
        const index = conversationList.map(function (e) {
          return e.id;
        }).indexOf(message.ConversationId);
        const targetConversation = {...conversationList[index]};
        if (targetConversation && (targetConversation.roles && targetConversation.roles.findIndex(u => u.user.email === state['userInfo'].email) !== -1)) {
          if (targetConversation.lastMessage && targetConversation.lastMessage.id === message.Id) {
            let newMessage = {...targetConversation.lastMessage};

            newEditedMessage.replyTo = newMessage.replyTo;
            newMessage = newEditedMessage;
            newMessage.isTemporary = false;
            targetConversation.lastMessage = newMessage;
            // console.log('NewState after message change', newState);
            conversationList[index] = targetConversation;
            conversationListInfo.queryConversations = conversationList;
            returnState = {
              ...returnState,
              conversationListInfo: conversationListInfo
            };
          }
        }
      }
      return {...returnState, editedMessage: newEditedMessage};
    }
    // Reading clears the conversation from the count: here when this tab reads it, and in any tab when the read comes
    // back. A read event is the reader's own exactly when every message it marked is read for this reader too: one who
    // read up to now in another tab, rather than a colleague reading messages this reader has not. Reading also clears
    // the reader's own "marked unread", as the server does (ITP-E-206-02, B-08), and their unread mention (ITP-E-207-03, B-02).
    case MESSAGE_READ: {
      const conversationId = action.command && action.command.conversationId;
      return conversationId
        ? changeListConversation(state, conversationId, c => ({...c, unreadMessageCount: 0, markedUnread: false, hasUnreadMention: false}))
        : state;
    }
    case OTHERS_MESSAGE_READ:
    case MESSAGE_READ_SUCCESS: {
      const readState = getReadMessageState();
      const marked = (action.payload && action.payload.Payload) || [];
      const readByMe: Record<string, boolean> = {};
      marked.forEach(message => {
        const id = message && message.ConversationId;
        if (id) {
          const mine = (message.Roles || []).some(role => role && role.IsRead && isMe(role.User && role.User.Email));
          readByMe[id] = (readByMe[id] !== false) && mine;
        }
      });
      return withListConversations(readState, conversations => conversations.some(c => c && readByMe[c.id])
        ? conversations.map(c => c && readByMe[c.id] ? {...c, unreadMessageCount: 0, markedUnread: false, hasUnreadMention: false} : c)
        : conversations);
    }
    // The reader pinned, muted, archived or marked a conversation unread (ITP-E-206-02): the row keeps the server's answer.
    case CONVERSATION_MARKS_CHANGED: {
      const changed = action as ConversationMarksChangedAction;
      if (!changed.conversationId || !changed.marks) {
        return state;
      }
      // ITP-E-240-04: as the server lists them, a chat pinned now leads the pins (the newest pin first), and one unpinned or
      // archived goes back by its latest message.
      return withListConversations(state, conversations => {
        const target = conversations.find(c => c && c.id === changed.conversationId);
        if (!target) {
          return conversations;
        }
        const marked = {...target, ...changed.marks};
        const others = conversations.filter(c => c !== target);
        return orderChatList(marked.isPinned && !target.isPinned
          ? [marked, ...others]
          : conversations.map(c => c === target ? marked : c));
      });
    }
    // Deleting a conversation for the reader takes it out of the list, and out of the count.
    case DELETE_CONVERSATION: {
      const ids: string[] = (action.command && action.command.conversationIds) || [];
      return ids.length ? withListConversations(state, conversations => conversations.filter(c => !c || ids.indexOf(c.id) === -1))
        : state;
    }
    // The reader leaving, here: the count drops it at once.
    case LEAVE_CONVERSATION: {
      const conversationId = action.command && action.command.conversationId;
      return conversationId ? markLeft(state, conversationId) : state;
    }
    // A membership change, here: the list keeps the conversation's new roles, so a member taken out stops counting.
    case MANAGE_PARTICIPANTS: {
      const command = action.command;
      return command && command.conversationId && command.participants
        // Copies: the command's records are its own, never shared with the chat or another row (ITP-E-204-07).
        ? changeListConversation(state, command.conversationId, c => ({...c, roles: command.participants.map(role => ({...role}))}))
        : state;
    }
    default:
      return state;
  }
}

/**
 * ITP-E-193-02: a pushed reply to a call row quotes the call as a card, as the next load will. The publish carries the
 * stored row — its call id, kind and caller, nothing per viewer — so the card words itself from those and CallService's
 * word on the call until the chat reloads. A deleted call row quotes as a deleted message.
 */
function replyToCallOf(replyTo, userEmail?: string) {
  if (!replyTo || !replyTo.CallInvitationId || replyTo.IsDeleted) {
    return {};
  }
  const author = replyTo.CreatedBy;
  const callerName = author ? `${author.FirstName || ''} ${author.LastName || ''}`.trim() || author.Email : null;
  return {
    id: replyTo.Id,
    sequence: replyTo.Sequence,
    callInvitationId: replyTo.CallInvitationId,
    callType: replyTo.CallType,
    callerEmail: author ? author.Email : null,
    callerName,
    isMine: !!userEmail && !!author && (author.Email || '').toLowerCase() === userEmail.toLowerCase()
  };
}

/** A card's meta line for a reader of another company than its row's (ITP-E-208-02, D-08), as the server words it. */
export const MEETING_UNAVAILABLE_META = "This meeting isn't available to you";

/**
 * The card fields of a pushed card row (B-20, ITP-E-208-01), as the thread query names them; none on any other message.
 * The push carries the card as the row's own company sees it, so a reader of another company gets it the way the next load
 * builds it for them (ITP-E-208-02): no action, "This meeting isn't available to you", `meetingAvailable` false.
 */
function messageCardOf(payload, readerCompanyId?: string) {
  const card = payload && payload.Card;
  if (!card || !card.Kind || payload.IsDeleted) {
    return {};
  }
  const available = !payload.CompanyId || !readerCompanyId
    || String(payload.CompanyId).toLowerCase() === String(readerCompanyId).toLowerCase();
  return {
    meetingId: payload.MeetingId || null,
    meetingAvailable: available,
    card: {
      kind: card.Kind,
      title: card.Title,
      meta: available ? card.Meta : MEETING_UNAVAILABLE_META,
      // An event card's start (ITP-E-208-04): the cards adapter words it for the reader.
      startsAtUtc: card.StartsAtUtc || null,
      // "link" on the card a pasted Meet link brought (ITP-E-208-06): the list previews it as shared, not started.
      via: card.Via || null,
      action: available && card.Action ? {label: card.Action.Label, url: card.Action.Url} : null
    }
  };
}

/**
 * MOBILE-E-104-11: whether a pushed row is a system line — the server's `SystemMessageType`, a number or its name; zero
 * (`NonSystemMessage`) is a message. The thread draws a system line centred, as it draws one read from the query.
 */
export function isPushedSystemLine(systemMessageType: any): boolean {
  if (typeof systemMessageType === 'number') {
    return systemMessageType !== 0;
  }
  return !!systemMessageType && systemMessageType !== 'NonSystemMessage';
}

/**
 * MOBILE-E-104-11: a pushed system line is named for everyone ("Nadia Harness added XatBot"); to the one who did it, it
 * reads "You added XatBot", as the line read from the query does.
 */
export function pushedSystemText(payload: any, userEmail?: string): string {
  const text = payload?.Message || '';
  const by = payload?.CreatedBy;
  if (!userEmail || !by?.Email || by.Email.toLowerCase() !== userEmail.toLowerCase()) {
    return text;
  }
  const name = [by.FirstName, by.LastName].filter(Boolean).join(' ').trim();
  return name && text.startsWith(name + ' ') ? 'You' + text.substring(name.length) : text;
}

function getNewMessage(payload, isMine, userEmail?: string, readerCompanyId?: string) {
  const systemLine = isPushedSystemLine(payload.SystemMessageType);
  return {
    message: systemLine ? pushedSystemText(payload, userEmail) : payload.Message,
    isSystemMessage: systemLine,
    // MOBILE-E-104-11: an Assistant's answer says who asked as soon as it arrives, as the next read does.
    askedBy: payload.AskedBy?.Email ? {email: payload.AskedBy.Email, name: payload.AskedBy.Name || ''} : null,
    sequence: payload.Sequence,
    attachment: payload.Attachment,
    parentId: payload.ParentId,
    isMine: isMine,
    createdBy: {
      email: payload.CreatedBy ? payload.CreatedBy.Email : null,
      firstName: payload.CreatedBy ? payload.CreatedBy.FirstName : null,
      lastName: payload.CreatedBy ? payload.CreatedBy.LastName : null,
      userName: payload.CreatedBy ? payload.CreatedBy.UserName : null
    },
    supportAccessSessionId: payload.SupportAccessSessionId || null,
    createdDate: payload.CreatedDate,
    messageType: payload.MessageType,
    systemMessageType: payload.SystemMessageType,
    data: payload.Data && payload.Data.length ? [{
      displayText: payload.Data[0] ? payload.Data[0].DisplayText : null,
      dataType: payload.Data[0] ? payload.Data[0].DataType : null,
      fieldKey: payload.Data[0] ? payload.Data[0].FieldKey : null,
      title: payload.Data[0] ? payload.Data[0].Title : null,
      sourceType: payload.Data[0] ? payload.Data[0].SourceType : null,
      newValue: payload.Data[0] ? payload.Data[0].NewValue : null,
      oldValue: payload.Data[0] ? payload.Data[0].OldValue : null,
      pageNo: payload.Data[0] ? payload.Data[0].PageNo : null,
      groupName: payload.Data[0] ? payload.Data[0].GroupName : null
    }] : null,
    // MEET-E-24-03: the Meeting Files a pushed message carries (a new one, or the host's approve / decline as an edit).
    files: Array.isArray(payload.Files) ? payload.Files.map(f => ({
      id: f.Id,
      name: f.Name,
      size: f.Size,
      contentType: f.ContentType,
      state: f.State,
      uploadedBy: f.UploadedBy ? {email: f.UploadedBy.Email, firstName: f.UploadedBy.FirstName, lastName: f.UploadedBy.LastName} : null
    })) : [],
    // B-19 (ITP-E-207-07): the chat files a pushed message carries, as the thread query names them.
    attachments: Array.isArray(payload.Attachments) && !payload.IsDeleted ? payload.Attachments.map(a => ({
      id: a.Id,
      name: a.Name,
      size: a.Size,
      type: a.ContentType,
      thumbnail: a.Thumbnail || null,
      // ITP-E-249-01 (B-25): a voice message's length; null for any other file.
      voiceDurationMs: a.VoiceDurationMs ?? null,
      // ITP-E-249-04 (B-25): its waveform's 48 peaks; null for any other file and a voice message without them.
      voicePeaks: a.VoicePeaks ?? null
    })) : [],
    // ITP-E-249-06 (B-25): a voice message's mark, its clip's length, which the list preview and a reply's quote word; none on a
    // deleted message.
    voiceDurationMs: payload.IsDeleted ? null : payload.VoiceDurationMs ?? null,
    id: payload.Id,
    isEdited: payload.IsEdited,
    isDeleted: payload.IsDeleted,
    conversationId: payload.ConversationId,
    hashTags: payload.HashTags,
    // D-18 (ITP-E-189-11): a call row arrives like any message; the call id is its only marker, the card words itself
    // from CallService's live word on the call (CallStarted / CallEnded / CallMissed) until the chat reloads.
    ...(payload.CallInvitationId ? {
      callInvitationId: payload.CallInvitationId,
      callType: payload.CallType,
      callerEmail: payload.CreatedBy ? payload.CreatedBy.Email : null
    } : {}),
    // B-20 (ITP-E-208-01): a meeting card row is pushed with the card the server built for it, so an open chat shows the
    // card at once, as the next load will.
    ...messageCardOf(payload, readerCompanyId),
    replyTo: {
      // ITP-E-193-03: the quote goes to the message it answers, by its sequence.
      id: payload.ReplyTo ? payload.ReplyTo.Id : null,
      sequence: payload.ReplyTo ? payload.ReplyTo.Sequence : null,
      isDeleted: payload.ReplyTo ? payload.ReplyTo.IsDeleted : null,
      message: payload.ReplyTo ? payload.ReplyTo.Message : null,
      // ITP-E-249-06: a quoted voice message reads "Voice message (0:42)" by its mark.
      voiceDurationMs: payload.ReplyTo && !payload.ReplyTo.IsDeleted ? payload.ReplyTo.VoiceDurationMs ?? null : null,
      createdBy: {
        email: payload.ReplyTo && payload.ReplyTo.CreatedBy ? payload.ReplyTo.CreatedBy.Email : null,
        firstName: payload.ReplyTo && payload.ReplyTo.CreatedBy ? payload.ReplyTo.CreatedBy.FirstName : null,
        lastName: payload.ReplyTo && payload.ReplyTo.CreatedBy ? payload.ReplyTo.CreatedBy.LastName : null,
        userName: payload.ReplyTo && payload.ReplyTo.CreatedBy ? payload.ReplyTo.CreatedBy.UserName : null
      },
      ...replyToCallOf(payload.ReplyTo, userEmail)
    }
  };

}

function getNewConversation(payload, currentUserEmail) {
  return {
    conversationType: payload.ConversationType,
    conversationStatus: payload.ConversationStatus,
    isGroupChat: payload.IsGroupChat,
    id: payload.Id,
    sourceType: payload.SourceType,
    title: payload.Title,
    parentId: payload.ParentId,
    contentScope: payload.ContentScope,
    initialMessage: payload.InitialMessage? getNewMessage(payload.InitialMessage, currentUserEmail === (payload.InitialMessage ? payload.InitialMessage.CreatedBy.Email : '') ) : null,
    messages: []
};

}

const updateContextByPath = function (state: CollaborationState, payload: any, messageFromPayload: { message; isMine: any; createdBy: { email: any; firstName: any; lastName: any; userName: any }; createdDate: Date; messageType: any; data: { displayText: any; dataType: string; fieldKey: any; title: any; sourceType: any; newValue: any; oldValue: any; pageNo: any; groupName: any }[]; id; replyTo: { message: any } }) {
  let contextByPathDeepClone = state.contextByPath;
  if (state.contextByPath && state.contextByPath.conversations) {
    const conversationIndex = state.contextByPath.conversations.findIndex(c => c.id == payload.ConversationId);
    contextByPathDeepClone = {
      ...state.contextByPath,
      conversations: [
        ...state.contextByPath.conversations
      ]
    };

    for (let i = 0; i < contextByPathDeepClone.conversations.length; i++) {
      contextByPathDeepClone.conversations[i].messages = contextByPathDeepClone.conversations[i].messages ? [...contextByPathDeepClone.conversations[i].messages] : [];
    }

    if (conversationIndex >= 0 && contextByPathDeepClone.conversations[conversationIndex] && !contextByPathDeepClone.conversations[conversationIndex].hasLeft && (contextByPathDeepClone.conversations[conversationIndex].roles && contextByPathDeepClone.conversations[conversationIndex].roles.findIndex(u => u.user.email === state['userInfo'].email) !== -1)) {
      contextByPathDeepClone.conversations[conversationIndex].messages ?
        contextByPathDeepClone.conversations[conversationIndex].messages.push(messageFromPayload) :
        contextByPathDeepClone.conversations[conversationIndex].messages = [messageFromPayload];
    }
  }
  return contextByPathDeepClone;
};

const updateEditedMessageInContextByPath = function (state: CollaborationState, payload: any, messageFromPayload: { message; isMine: any; createdBy: { email: any; firstName: any; lastName: any; userName: any }; createdDate: Date; messageType: any; data: { displayText: any; dataType: string; fieldKey: any; title: any; sourceType: any; newValue: any; oldValue: any; pageNo: any; groupName: any }[]; id; replyTo: { message: any } }) {
  let contextByPathDeepClone = state.contextByPath;
  if (state.contextByPath && state.contextByPath.conversations) {
    const conversationIndex = state.contextByPath.conversations.findIndex(c => c.id === payload.ConversationId);
    contextByPathDeepClone = {
      ...state.contextByPath,
      conversations: [
        ...state.contextByPath.conversations
      ]
    };

    for (let i = 0; i < contextByPathDeepClone.conversations.length; i++) {
      contextByPathDeepClone.conversations[i].messages = contextByPathDeepClone.conversations[i].messages ? [...contextByPathDeepClone.conversations[i].messages] : [];
    }

    if (conversationIndex >= 0 && contextByPathDeepClone.conversations[conversationIndex]) {
      if (!contextByPathDeepClone.conversations[conversationIndex].messages) {
        contextByPathDeepClone.conversations[conversationIndex].messages = [];
      }
      const messageIndex = contextByPathDeepClone.conversations[conversationIndex].messages.findIndex(m => m.id === messageFromPayload.id);
      if (messageIndex >= 0 && contextByPathDeepClone.conversations[conversationIndex].messages[messageIndex]) {
        contextByPathDeepClone.conversations[conversationIndex].messages[messageIndex] = messageFromPayload;
      }
    }
  }
  return contextByPathDeepClone;
};
